import { tryRefreshTokens } from '~/composables/useAuth'

const PUBLIC_PATHS = ['/login', '/set-password', '/forgot-password', '/callback', '/login-error', '/signup', '/verify-email']

function getTokenExpiry(token: string): number {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]!)) as { exp: number }
    return payload.exp
  } catch {
    return 0
  }
}

function isExpired(token: string): boolean {
  const exp = getTokenExpiry(token)
  return exp === 0 || Date.now() / 1000 >= exp
}

export default defineNuxtRouteMiddleware(async (to) => {
  if (PUBLIC_PATHS.includes(to.path)) return
  if (to.path.startsWith('/join/')) return
  if (import.meta.server) return

  const token = localStorage.getItem('access_token')
  if (!token) {
    return navigateTo('/login')
  }

  if (isExpired(token)) {
    // Resolve config values NOW (before any await) while Nuxt instance is available
    const config = useRuntimeConfig()
    const clientId = config.public.cognitoClientId as string
    const poolId = config.public.cognitoUserPoolId as string
    const region = poolId.split('_')[0] ?? 'ap-southeast-1'
    const endpoint = `https://cognito-idp.${region}.amazonaws.com/`

    const refreshed = await tryRefreshTokens(endpoint, clientId)
    if (!refreshed) {
      localStorage.removeItem('access_token')
      localStorage.removeItem('id_token')
      localStorage.removeItem('refresh_token')
      return navigateTo('/login')
    }
  }
})
